import { render, staticRenderFns } from "./ContactInformationModal.vue?vue&type=template&id=8684b0ae&scoped=true"
import script from "./ContactInformationModal.vue?vue&type=script&lang=ts"
export * from "./ContactInformationModal.vue?vue&type=script&lang=ts"
import style0 from "./ContactInformationModal.vue?vue&type=style&index=0&id=8684b0ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8684b0ae",
  null
  
)

export default component.exports